<template>
    <div class="swiper">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
// .swiper{
//   width: 100vw;
//   height: 100vh;
//   background-image: url(../assets/imgs/allbg1.png);
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   position: absolute;
//   z-index: 2;
// //   pointer-events: none; 
//   position: relative;
  
// }
</style>